import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

import Modal from '../../../components/ui/modal';
import {
  StyledHeading,
  SubmitButton,
  InputLabel,
  HeaderWrapper,
  DetailTable,
  DetailTableWrapper,
  InputWrapper,
  SearchButton,
  StyledInput,
  ErrorText,
  SumWrapper,
  SumText,
  SumLabel,
  NoContent,
  LoadingWrapper,
  AutomaticSaleModalSC,
  InputRow,
  CheckboxWrapper,
  TableHead,
} from './automatic-sale-modal.styled';
import { Formik, Form } from 'formik';
import { SmallText } from '../../typography';
import useWindowSize from '../../../utils/screen-size';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import SaleTableItem from './sale-table-item';
import { connect } from 'react-redux';
import { validation } from './automatic-sale-modal.schema';
import SmsVerification from '../../sms-verification';
import * as ActionCreators from '../../../redux/action';
import { bindActionCreators } from 'redux';
import InlineLoading from '../../ui/inline-loading';
import SuccessModal from '../../success-modal';
import Checkbox from '../../ui/checkbox';
import numeral from 'numeral';

function sumSelected(selected = {}) {
  let selectedCount = 0;

  const sum = Object.values(selected).reduce((prev, next) => {
    if (next !== false) {
      selectedCount += 1;
      return prev + next;
    }
    return prev;
  }, 0);

  return { sum, selectedCount };
}

function AutomaticSaleModal({
  visible,
  onClose,
  investmentsForSale,
  sendSms,
  postInvestmentsForSale,
  getInvestmentsForSale,
  setInvestmentsForSale,
  onSuccess,
  investmentsForSaleLoading,
}) {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;
  const [prevSearch, setPrevSearch] = useState('');
  const [smsModalOpen, setSmsModalOpen] = useState(false);
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [sellError, setSellError] = useState(false);
  const [isSuccessModalOpened, setIsSuccessModalOpened] = useState(false);
  const [vop, setVop] = useState(false);
  const [unsuccess, setUnsuccess] = useState(false);
  const [success, setSuccess] = useState(false);
  const approvalsChecked = vop && unsuccess && success;

  function onSubmit(values, helpers) {
    onSmsSend();
    setFormValues(values);
  }

  function onSearch(value) {
    getInvestmentsForSale(value);
    setPrevSearch(value);
  }

  /* Send sms */
  function onSmsSend() {
    sendSms({ type: 'offer-automatically-multiple' });
    setSmsModalOpen(true);
  }

  function onConfirm(data) {
    setIsSending(true);
    const investmentsIds = [];
    Object.keys(formValues.selected).forEach((key) => {
      if (formValues.selected[key] !== false) {
        investmentsIds.push(key);
      }
    });

    postInvestmentsForSale(
      {
        sms_code: data.sms_code,
        investmentsIds,
      },
      () => {
        setIsSending(false);
        setSmsModalOpen(false);
        setPrevSearch('');
        setInvestmentsForSale([]);
        setIsSuccessModalOpened(true);
        onSuccess();
        setSellError(false);
      },
      () => {
        setIsSmsCodeError(true);
        setIsSending(false);
      },
      () => {
        setSellError(true);
        setIsSending(false);
      }
    );
  }

  function renderApprovals(count) {
    return (
      <CheckboxWrapper>
        <div className="checkbox-wrap">
          <Checkbox
            name="vop"
            hasError={false}
            value={vop}
            checked={vop || false}
            onChange={() => setVop(!vop)}
            withInsideContent
            bold={false}
            labelClassName="label"
          >
            <FormattedHTMLMessage
              id="investor_loan_detail_sell_modal_vop_label"
              defaultMessage={dlt['investor_loan_detail_sell_modal_vop_label']}
              values={{
                link1: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`,
                link2: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/sadzobnik_poplatkov.pdf`,
              }}
            />
          </Checkbox>
        </div>
        <div className="checkbox-wrap">
          <Checkbox
            name="unsuccess"
            hasError={false}
            value={unsuccess}
            checked={unsuccess || false}
            onChange={() => setUnsuccess(!unsuccess)}
            withInsideContent
            bold={false}
            labelClassName="label"
          >
            {count === 1 ? (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_unsuccessful_label"
                defaultMessage={dlt['investor_loan_detail_sell_modal_unsuccessful_label']}
              />
            ) : (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_unsuccessful_label_multiple_items"
                defaultMessage={
                  dlt['investor_loan_detail_sell_modal_unsuccessful_label_multiple_items']
                }
              />
            )}
          </Checkbox>
        </div>
        <div className="checkbox-wrap">
          <Checkbox
            name="success"
            hasError={false}
            value={success}
            checked={success || false}
            onChange={() => setSuccess(!success)}
            withInsideContent
            bold={false}
            labelClassName="label"
          >
            {count === 1 ? (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_successful_label_automatic"
                defaultMessage={dlt['investor_loan_detail_sell_modal_successful_label_automatic']}
              />
            ) : (
              <FormattedHTMLMessage
                id="investor_loan_detail_sell_modal_successful_label_automatic_multiple_items"
                defaultMessage={
                  dlt['investor_loan_detail_sell_modal_successful_label_automatic_multiple_items']
                }
              />
            )}
          </Checkbox>
        </div>
      </CheckboxWrapper>
    );
  }

  return (
    <AutomaticSaleModalSC>
      <Modal isOpened={visible} withCross onClose={onClose} closeOnDocumentClick={false}>
        <Formik
          enableReinitialize
          initialValues={{
            search: prevSearch,
            selected:
              investmentsForSale?.reduce((prev, next) => {
                prev[next.id] = Number(next.totalTillEnd[9]);
                return prev;
              }, {}) || {},
          }}
          onSubmit={onSubmit}
          validationSchema={validation}
        >
          {({ values, errors, handleChange, handleBlur, setFieldValue, dirty }) => {
            const { sum, selectedCount } = sumSelected(values.selected);

            return (
              <Form>
                <HeaderWrapper>
                  <StyledHeading>
                    <FormattedMessage id="investor_investments_auto_sale_modal_title" />
                  </StyledHeading>
                  <InputRow>
                    <InputWrapper>
                      <InputLabel>
                        <FormattedMessage
                          id="investor_investments_auto_sale_modal_input_label"
                          defaultMessage={dlt['investor_investments_auto_sale_modal_input_label']}
                        />
                      </InputLabel>
                      <FormattedMessage id="investor_investments_auto_sale_modal_input_placeholder">
                        {(placeholder) => (
                          <StyledInput
                            type="text"
                            name="search"
                            placeholder={placeholder}
                            filled={values.search}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.search || ''}
                          />
                        )}
                      </FormattedMessage>
                    </InputWrapper>
                    <SearchButton
                      type="OUTLINED"
                      onClick={() => {
                        onSearch(values.search);
                      }}
                      disabled={!values.search || errors.search}
                    >
                      <FormattedMessage id="investor_investments_auto_sale_modal_search_btn" />
                    </SearchButton>
                  </InputRow>
                </HeaderWrapper>
                <DetailTableWrapper>
                  <DetailTable>
                    {isTablet ? null : (
                      <TableHead>
                        <tr>
                          <th />
                          <th>
                            <SmallText className="black-transparent">
                              <FormattedMessage
                                id="investor_investments_table_name"
                                defaultMessage={dlt['investor_investments_table_name']}
                              />
                            </SmallText>
                          </th>
                          <th>
                            <SmallText className="black-transparent">
                              <FormattedMessage
                                id="investor_investments_auto_sale_modal_table_value"
                                defaultMessage={
                                  dlt['investor_investments_auto_sale_modal_table_value']
                                }
                              />
                            </SmallText>
                          </th>
                          <th>
                            <SmallText className="black-transparent">
                              <FormattedMessage
                                id="investor_investments_table_payments"
                                defaultMessage={dlt['investor_investments_table_payments']}
                              />
                            </SmallText>
                          </th>
                          <th>
                            <SmallText className="black-transparent">
                              <FormattedMessage
                                id="investor_investments_table_date"
                                defaultMessage={dlt['investor_investments_table_date']}
                              />
                            </SmallText>
                          </th>
                          <th>
                            <SmallText className="black-transparent">
                              <FormattedMessage
                                id="investor_investments_table_status"
                                defaultMessage={dlt['investor_investments_table_status']}
                              />
                            </SmallText>
                          </th>
                        </tr>
                      </TableHead>
                    )}
                    {!investmentsForSaleLoading && (
                      <tbody>
                        {investmentsForSale?.map((item) => {
                          return (
                            <SaleTableItem
                              hasPagination={false}
                              key={item.loan.id}
                              name={item.debtor.wmNumber}
                              payments={item.loan.paidInstallmentCount}
                              paymentsTotal={item.loan.totalInstallmentCount}
                              restValue={Number(item.totalTillEnd[9])}
                              originalValue={Number(item.totalTillEnd[3])}
                              date={item.loan.loanDueAt}
                              status={item.totalTillEnd[12] > 0 ? 'late' : 'done'}
                              inArrear={item.totalTillEnd[12]}
                              isTablet={isTablet}
                              lastPaymentDate={item.loan.lastPaymentDate}
                              checkable
                              onClick={() => {
                                const value = values.selected[item.id]
                                  ? false
                                  : Number(item.totalTillEnd[9]);
                                setFieldValue(`selected.${item.id}`, value);
                              }}
                              checked={values.selected[item.id]}
                            />
                          );
                        })}
                      </tbody>
                    )}
                  </DetailTable>
                  {investmentsForSaleLoading && (
                    <LoadingWrapper>
                      <InlineLoading />
                    </LoadingWrapper>
                  )}
                  {!investmentsForSale?.length && !investmentsForSaleLoading && (
                    <NoContent>
                      <FormattedMessage id="investor_investments_auto_sale_modal_table_empty" />
                    </NoContent>
                  )}
                </DetailTableWrapper>
                {sum > 0 ? (
                  <SumWrapper>
                    <SumLabel>
                      <FormattedMessage
                        id="investor_investments_auto_sale_modal_table_sum"
                        defaultMessage={dlt['investor_investments_auto_sale_modal_table_sum']}
                      />
                    </SumLabel>
                    <SumText>{numeral(sum).format('0,0.00')} €</SumText>
                  </SumWrapper>
                ) : null}
                {renderApprovals(selectedCount)}
                <SubmitButton
                  type="PRIMARY"
                  disabled={
                    Object.keys(values.selected).length === 0 ||
                    errors.selected ||
                    !approvalsChecked
                  }
                >
                  <FormattedMessage id="investor_investments_auto_sale_modal_submit_btn" />
                </SubmitButton>
                {dirty && errors.selected && values.search !== '' && investmentsForSale?.length && (
                  <ErrorText>
                    <FormattedMessage id={errors.selected} />
                  </ErrorText>
                )}
              </Form>
            );
          }}
        </Formik>
      </Modal>
      <Modal
        isOpened={smsModalOpen}
        onClose={() => {
          setSmsModalOpen(false);
          setSellError(false);
        }}
        className="special"
        withCross
        closeOnDocumentClick={false}
      >
        <SmsVerification
          onSubmit={(data) => onConfirm(data)}
          additionalData={{}}
          isError={isSmsCodeError}
          errorMessage={sellError ? 'investor_investments_auto_sale_modal_table_error' : ''}
          isSending={isSending}
          onResend={() => onSmsSend()}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </Modal>
      <Modal
        isOpened={isSuccessModalOpened}
        onClose={() => {
          setIsSuccessModalOpened(false);
          setFormValues({});
        }}
        className="special"
        withCross
        closeOnDocumentClick={false}
      >
        {isSuccessModalOpened ? (
          sumSelected(formValues.selected).selectedCount > 1 ? (
            <SuccessModal
              headlineText={'investor_investments_auto_sale_modal_table_success_multiple_items'}
            />
          ) : (
            <SuccessModal headlineText={'investor_investments_auto_sale_modal_table_success'} />
          )
        ) : null}
      </Modal>
    </AutomaticSaleModalSC>
  );
}

AutomaticSaleModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    investmentsForSale: state.investmentsForSale,
    investmentsForSaleLoading: state.investmentsForSaleLoading,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      postInvestmentsForSale: ActionCreators.postInvestmentsForSale,
      getInvestmentsForSale: ActionCreators.getInvestmentsForSale,
      setInvestmentsForSale: ActionCreators.setInvestmentsForSale,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AutomaticSaleModal);
